import Resource from './Resource';

export default class ClassPageGrades extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;



		let config = {
			route: `class-pages/:courseSectionGuid/grades-breakdown`,
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
